import * as Colors from "./grayyellow/colors";
import * as Palette from "./grayyellow/palette";
import * as Overrides from "./grayyellow/overrides"

const CustomTheme = {
   colors: Colors,
   palette: Palette,
   overrides: Overrides
}

export default CustomTheme;
